/**
 * Column template shared by the companies table header row
 * (`pages/CompaniesIndex.vue`) and every data row (`CompaniesCard.vue`).
 *
 * Kept here so the header labels and the values underneath them cannot drift
 * apart. Tailwind already scans the `components-next` js files, so the
 * utilities below are picked up by JIT.
 */
export const COMPANY_ROW_GRID =
  'grid grid-cols-[minmax(16rem,2fr)_minmax(8rem,1fr)_minmax(9rem,1fr)_minmax(9rem,1fr)] items-center gap-x-4';

export const COMPANY_TABLE_MIN_WIDTH = 'min-w-[44rem]';
